<div class="relative">
  <app-transaction-timer class="block absolute right-2 top-2" />
</div>

<main class="flex justify-center items-start min-h-screen w-full relative">
  <div class="w-full max-w-[680px]">
    <router-outlet />
  </div>
</main>

<p-toast position="center" [life]="3000">
  <ng-template #message let-msg>
    <div class="flex items-center gap-3 flex-1 py-1 px-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-white flex-shrink-0"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="text-white font-medium text-sm flex-1">{{ msg.detail }}</span>
    </div>
  </ng-template>
</p-toast>

<!-- @if (!isOnline()) {
  <div
    class="flex h-screen w-full items-center justify-center bg-[#2e2e2e7e] bg-opacity-50 backdrop-blur-[2px] fixed top-0 left-0 right-0 bottom-0 z-50 pointer-events-none"
  >
    <div class="p-5 bg-white border border-gray-400 rounded-lg text-center m-3">
      <svg
        class="mx-auto mb-2"
        width="64px"
        height="64px"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <g fill="#2e3436">
            <path
              d="m 8 1.992188 c -2.617188 0 -5.238281 0.933593 -7.195312 2.808593 l -0.496094 0.480469 c -0.3984378 0.378906 -0.410156 1.011719 -0.03125 1.410156 c 0.382812 0.398438 1.015625 0.410156 1.414062 0.027344 l 0.5 -0.476562 c 3.085938 -2.953126 8.53125 -2.953126 11.617188 0 l 0.5 0.476562 c 0.398437 0.382812 1.03125 0.371094 1.414062 -0.027344 c 0.378906 -0.398437 0.367188 -1.03125 -0.03125 -1.410156 l -0.496094 -0.480469 c -1.957031 -1.875 -4.578124 -2.808593 -7.195312 -2.808593 z m -0.03125 4.007812 c -1.570312 0.011719 -3.128906 0.628906 -4.207031 1.8125 l -0.5 0.550781 c -0.375 0.40625 -0.347657 1.042969 0.0625 1.414063 c 0.410156 0.371094 1.042969 0.339844 1.414062 -0.070313 l 0.5 -0.542969 c 1.242188 -1.363281 3.992188 -1.492187 5.398438 -0.128906 c 0.121093 -0.023437 0.242187 -0.035156 0.363281 -0.035156 c 0.53125 0 1.039062 0.210938 1.414062 0.585938 l 0.222657 0.222656 c 0.011719 -0.011719 0.023437 -0.019532 0.039062 -0.03125 c 0.40625 -0.371094 0.4375 -1.007813 0.0625 -1.414063 l -0.5 -0.550781 c -1.125 -1.230469 -2.703125 -1.824219 -4.269531 -1.8125 z m 0.03125 4 c -0.511719 0 -1.023438 0.195312 -1.414062 0.585938 c -0.78125 0.78125 -0.78125 2.046874 0 2.828124 s 2.046874 0.78125 2.828124 0 c 0.210938 -0.210937 0.359376 -0.453124 0.457032 -0.714843 l -0.285156 -0.285157 c -0.554688 -0.554687 -0.707032 -1.367187 -0.46875 -2.070312 c -0.335938 -0.226562 -0.726563 -0.34375 -1.117188 -0.34375 z m 0 0"
              fill-opacity="0.34902"
            ></path>
            <path
              d="m 11 10 c -0.265625 0 -0.519531 0.105469 -0.707031 0.292969 c -0.390625 0.390625 -0.390625 1.023437 0 1.414062 l 1.292969 1.292969 l -1.292969 1.292969 c -0.390625 0.390625 -0.390625 1.023437 0 1.414062 s 1.023437 0.390625 1.414062 0 l 1.292969 -1.292969 l 1.292969 1.292969 c 0.390625 0.390625 1.023437 0.390625 1.414062 0 s 0.390625 -1.023437 0 -1.414062 l -1.292969 -1.292969 l 1.292969 -1.292969 c 0.390625 -0.390625 0.390625 -1.023437 0 -1.414062 c -0.1875 -0.1875 -0.441406 -0.292969 -0.707031 -0.292969 s -0.519531 0.105469 -0.707031 0.292969 l -1.292969 1.292969 l -1.292969 -1.292969 c -0.1875 -0.1875 -0.441406 -0.292969 -0.707031 -0.292969 z m 0 0"
            ></path>
          </g>
        </g>
      </svg>
      <p class="text-xl text-gray-600 font-bold">You are offline</p>
      <p class="text-xl text-gray-600 font-bold">Please check your internet.</p>
    </div>
  </div>
}
@else if (isConnectionSlow()) {
  <div
    class="flex h-screen w-full items-center justify-center bg-[#2e2e2e7e] bg-opacity-50 backdrop-blur-[2px] fixed top-0 left-0 right-0 bottom-0 z-50 pointer-events-none"
  >
    <div class="p-5 bg-white border border-gray-400 rounded-lg text-center m-3">
      <svg
        class="mx-auto mb-2"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="64px"
        height="64px"
        viewBox="0 0 320.334 320.334"
        xml:space="preserve"
        fill="#2e343670"
        stroke="#2e343670"
        stroke-width="4.80501"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="#CCCCCC"
          stroke-width="0.640668"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <g>
            <g>
              <path
                style="fill: #030303"
                d="M160.17,115.727c-11.868,0-23.029,4.626-31.42,13.02c-8.394,8.391-13.014,19.553-13.014,31.42 c0,11.854,4.62,23.038,13.014,31.415c8.391,8.394,19.553,13.02,31.42,13.02c11.868,0,23.035-4.626,31.418-13.02 c8.394-8.4,13.025-19.55,13.025-31.421c0-11.867-4.632-23.029-13.025-31.42C183.205,120.353,172.038,115.727,160.17,115.727z M183.308,183.308c-6.181,6.182-14.395,9.589-23.138,9.589c-8.743,0-16.957-3.407-23.141-9.589 c-6.181-6.187-9.583-14.397-9.583-23.141c0-8.749,3.402-16.968,9.583-23.146c6.184-6.176,14.398-9.583,23.141-9.583 c8.737,0,16.957,3.407,23.138,9.589c6.188,6.184,9.595,14.398,9.595,23.141C192.902,168.91,189.495,177.121,183.308,183.308z"
              ></path>
              <path
                style="fill: #030303"
                d="M101.472,101.469c-15.676,15.673-24.313,36.524-24.313,58.698c0,22.181,8.631,43.028,24.313,58.695 l8.28-8.279c-13.463-13.46-20.882-31.369-20.882-50.416s7.414-36.953,20.882-50.418L101.472,101.469z"
              ></path>
              <path
                style="fill: #030303"
                d="M218.868,101.469l-8.279,8.28c13.466,13.466,20.876,31.372,20.876,50.418 s-7.41,36.956-20.876,50.416l8.279,8.279c15.685-15.679,24.313-36.515,24.308-58.695 C243.182,137.993,234.553,117.147,218.868,101.469z"
              ></path>
              <path
                style="fill: #030303"
                d="M55.19,55.188l-8.277-8.277C16.665,77.159,0,117.376,0,160.167 c0,42.788,16.659,83.009,46.913,113.257l8.277-8.269c-28.033-28.041-43.48-65.322-43.48-104.988 C11.71,120.51,27.152,83.223,55.19,55.188z"
              ></path>
              <path
                style="fill: #030303"
                d="M273.424,46.91l-8.279,8.277c28.041,28.041,43.479,65.328,43.479,104.979 c0,39.644-15.438,76.947-43.469,104.988l8.269,8.269c30.26-30.248,46.91-70.469,46.91-113.257 C320.334,117.376,303.684,77.159,273.424,46.91z"
              ></path>
              <path
                style="fill: #030303"
                d="M82.465,82.468l-8.279-8.279c-47.411,47.411-47.411,124.547,0,171.972l8.279-8.279 C39.623,195.029,39.623,125.31,82.465,82.468z"
              ></path>
              <path
                style="fill: #030303"
                d="M246.16,74.188l-8.279,8.279c42.827,42.842,42.827,112.562,0,155.413l8.279,8.279 C293.546,198.735,293.546,121.593,246.16,74.188z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <p class="text-xl text-gray-600 font-bold">Your connection seems slow</p>
    </div>
  </div>
} -->
